import { HTTPError } from 'ky';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ShopTypes } from '~/lib/data-contract';
import { useSession } from 'next-auth/react';
import { setCustomUserProfile } from '../../operations/mit-fog';

export default function useSetCustomUserProfile() {
    const { data } = useSession();
    const token = data?.accessToken ?? null;
    const queryClient = useQueryClient();

    return useMutation<
        ShopTypes.UserInformationDto,
        HTTPError | Error,
        Omit<Parameters<typeof setCustomUserProfile>[0], 'token'>
    >(({ name, phoneNumber }) => setCustomUserProfile({ name, phoneNumber, token }), {
        onSuccess: () => {
            queryClient.invalidateQueries(['userProfile', { token }]);
        },
    });
}
